import React, { type ComponentProps } from 'react'
import { FLAGS } from '../config'
import { useFlagsContext } from '../providers'
import SingleViewCarousel from './SingleViewCarousel/SingleViewCarousel'
import { ZionCarousel } from './ZionCarousel'

type SingleViewCarouselProps = ComponentProps<typeof SingleViewCarousel>

export function Carousel(props: SingleViewCarouselProps): JSX.Element {
  const { [FLAGS.ZION_CAROUSEL]: zionCarouselFlag } = useFlagsContext()

  if (zionCarouselFlag?.isOn) {
    return <ZionCarousel {...props} />
  }

  return <SingleViewCarousel {...props} />
}
